/**
 * @generated SignedSource<<6162c6af84001fbe950022fe132f35d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type HideClassInput = {
  classId: string;
};
export type ClassCategoriesHideClassMutation$variables = {
  input: HideClassInput;
};
export type ClassCategoriesHideClassMutation$data = {
  readonly hideClass: {
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly message?: string;
    }> | null | undefined;
    readonly userClassCategoryNode: {
      readonly classId: string;
      readonly id: string;
    } | null | undefined;
  };
};
export type ClassCategoriesHideClassMutation = {
  response: ClassCategoriesHideClassMutation$data;
  variables: ClassCategoriesHideClassMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "HideClassPayload",
    "kind": "LinkedField",
    "name": "hideClass",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserClassCategoryNode",
        "kind": "LinkedField",
        "name": "userClassCategoryNode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "classId",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "type": "Error",
            "abstractKey": "__isError"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClassCategoriesHideClassMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClassCategoriesHideClassMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e5ea2ed48b01de67beabc4aaa8f2cbbc",
    "id": null,
    "metadata": {},
    "name": "ClassCategoriesHideClassMutation",
    "operationKind": "mutation",
    "text": "mutation ClassCategoriesHideClassMutation(\n  $input: HideClassInput!\n) {\n  hideClass(input: $input) {\n    userClassCategoryNode {\n      id\n      classId\n    }\n    errors {\n      __typename\n      ... on Error {\n        __isError: __typename\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a544d136c80faeaf30935dd33e742bb6";

export default node;
